import { enqueueSnackbar } from "notistack";
import axios from "axios";
import { workerActions } from "../../slices/workers";

export const deleteUsersId = "deleteUsers";

const deleteUsers = ({ server, cloner_key, users, locale }) => {
  const id = deleteUsersId;
  const UIText = {
    "es-CL": {
      success:
        users.length > 1
          ? "Usuarios eliminados exitosamente"
          : "Usuario eliminado exitosamente",
      error: "Error al intentar eliminar el usuario ",
      start: `Eliminando ${users.length} usuarios...`,
    },
    "en-US": {
      success: `User${users.length > 1 ? "s" : ""} deleted successfully`,
      error: "Error trying to delete user: ",
      start: `Deleting ${users.length} users`,
    },
  };
  const { start, success, error } = UIText[locale];

  return async (dispatch) => {
    if (users.length > 1) {
      enqueueSnackbar(start, { variant: "info" });
    }
    dispatch(workerActions.start(id));
    let currentUser = "";
    try {
      for (const user of users) {
        currentUser = user;
        const url = server + "api/users";
        await axios.delete(url, { params: { user }, headers: { cloner_key } });
      }

      enqueueSnackbar(success, { variant: "success" });
      dispatch(workerActions.finish({ id }));
    } catch (e) {
      console.error(e);
      enqueueSnackbar(error + currentUser + ": " + e.message, {
        variant: "error",
      });
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};

export default deleteUsers;
